/**
 * Created On : 23nd Feb 2018
 * Usage : Display points data click event of get data
 * Coprights : Johnson Controls India Pvt Ltd.
 **/
import { Component, EventEmitter, Output } from '@angular/core';
import { AssetService } from '../../services/asset.service';
import { PointService } from '../../services/point.service';
import { MobileDataService } from '../../services/mobile-data.service';
import { Platform, Loading, LoadingController } from 'ionic-angular';
import { Storage } from "@ionic/storage";
import { GetData } from '../../models/get-data';
import { DecimalPipe } from '@angular/common';
import { TranslateService } from "@ngx-translate/core";
import { DatePipe } from '@angular/common';
@Component({
    selector: 'points',
    templateUrl: 'points.html',
    providers: [TranslateService]
})
export class PointsComponent {
    @Output() hidePoints = new EventEmitter();
    public getData: GetData[] = [];
    public access_token: string;
    public fetchDataSpinner: Loading;

    constructor(
        private platform: Platform,
        private assetService: AssetService,
        private pointService: PointService,
        private dataService: MobileDataService,
        private storage: Storage,
        private loadingCtrl: LoadingController,
        public translate: TranslateService,        
        public datepipe: DatePipe
    ) {

    }
    ngOnInit() {
        if (this.platform.is("mobileweb") || this.platform.is("core")) {
            this.access_token = sessionStorage.getItem('access_token');
            this.getMobileData(this.access_token, 'getdata', this.assetService.asset.id, this.pointService.pointClicked.x);
        }
        else {
            this.storage.get('access_token').then((token) => {
                this.access_token = token;
                this.getMobileData(this.access_token, 'getdata', this.assetService.asset.id, this.pointService.pointClicked.x);
            })
        }
    }
    getMobileData(token, type, assetId, timestamp) {
        this.fetchDataSpinner = this.loadingCtrl.create({
            content: this.translate.instant('Fetchingdata'),
            spinner: 'bubbles'
        });
        this.fetchDataSpinner.present();
        this.dataService.getMobileData(token, assetId, type, timestamp)
            .subscribe((data) => {
                if(data && data.length > 0){
                    this.getData = data;
                }
                this.fetchDataSpinner.dismiss()
            }, (error) => this.fetchDataSpinner.dismiss());
    }

    hidePointsData() {
        this.hidePoints.emit(false);
    }
}



// WEBPACK FOOTER //
// ./src/components/points/points.ts